import { useQuery } from 'react-query';

import getHubToken from '@/common/api/users/mercure/getHubToken';
import { ENDPOINT_MERCURE_HUB_TOKEN } from '@/common/constants';

const useHubToken = (connexionRetry, isActive) =>
  useQuery([ENDPOINT_MERCURE_HUB_TOKEN, connexionRetry], getHubToken, {
    retry: 3,
    retryDelay: 1000,
    enabled: isActive,
  });

export default useHubToken;
